module.exports = __webpack_public_path__ + "197a709171d8fad2815b45b54264a9e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_robert_mobile_teaser.jpg
// module id = 676
// module chunks = 0